import * as React from "react";

const MinusIcon: React.FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path d="M3.3335 8H12.6668" stroke="#545454" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default React.memo(MinusIcon);
